import {
  FieldErrorsImpl,
  UseFormClearErrors,
  UseFormRegister,
  UseFormResetField,
  UseFormSetError,
  UseFormSetValue,
} from 'react-hook-form';
import { ICompanyProfileInfoRegister } from '../../../Types/RegisterTypes';
import CommonImageUpload from '../../../Components/Common/CommonImageUpload';
import InputField from '../../../Components/Common/InputField';
import SelectTextArea from '../../../Components/Common/SelectTextArea';
import { useEffect } from 'react';
import { BaseUrl } from '../../../Helpers/Constant';

type ICompanyProfile = {
  companyProfileReg: ICompanyProfileInfoRegister | null | undefined;
  register: UseFormRegister<any>;
  setError?: UseFormSetError<any>;
  clearErrors?: UseFormClearErrors<any>;
  setValue?: UseFormSetValue<any>;
  resetField?: UseFormResetField<any>;
  errors?: Partial<FieldErrorsImpl<any>>;
};
const CompanyProfile = ({
  register,
  companyProfileReg,
  setError,
  setValue,
  resetField,
  clearErrors,
  errors,
}: ICompanyProfile) => {
  const { companyName, address, mobileNumber, logo, email } =
    companyProfileReg || {};

  useEffect(() => {
    if (logo) {
      (async function fetchImageAsBinary(url: string) {
        try {
          // Fetch the image as a blob
          const response = await fetch(`${BaseUrl}/proxy-image?url=${url}`);
          const blob = await response.blob();

          // Set value to react hook
          setValue && setValue('user_fair_member_company_logo', blob);
        } catch (error) {
          console.error('Error fetching or uploading image:', error);
        }
      })(logo);
    }

    if (companyProfileReg) {
      setValue?.('user_fair_member_company_name', companyName);
      setValue?.('user_fair_member_company_email', email);
      setValue?.('user_fair_member_company_address', address);
      setValue?.('user_fair_member_company_telephone', mobileNumber);
    }
  }, [logo, companyProfileReg]);
  return (
    <>
      <div className='register-top '>
        <div className='register-top-div'>
          <h3>Company Profile </h3>
        </div>
        <div className='register-top-form-card'>
          <div className='row' style={{ rowGap: '8px' }}>
            <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
              <InputField
                type='text'
                isRequired
                label='Company Name'
                register={register('user_fair_member_company_name')}
                placeholder='Company Name'
                defaultValue={companyName}
                disabled={companyName ? true : false}
              />
            </div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
              <div>
                <InputField
                  type='email'
                  isRequired
                  label='Company Email'
                  register={register('user_fair_member_company_email')}
                  placeholder='Enter email'
                  defaultValue={email}
                  disabled={email ? true : false}
                />
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
              <div className='row'>
                <InputField
                  isRequired
                  label='City'
                  register={register('user_fair_member_company_city')}
                  placeholder='Enter city'
                />
              </div>
            </div>

            <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
              <div className='row exhib-reg-zip'>
                <InputField
                  label='Zip'
                  register={register('user_fair_member_company_zip')}
                  placeholder='Enter Zip'
                />
              </div>
            </div>

            <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
              <div className='row'>
                <InputField
                  label='Web Address'
                  register={register('user_fair_member_company_website')}
                  placeholder='Enter Web Address'
                />
              </div>
            </div>

            <input type='hidden' name='country' value='18' />

            <div className='col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3'>
              <div className='row'>
                <label>
                  Phone <span className='require'>*</span>
                </label>
                <div className='w-150-100'>
                  <input
                    required
                    type='text'
                    className='form-control'
                    {...register('user_fair_member_company_telephone')}
                    defaultValue={mobileNumber}
                    placeholder='Enter company phone number'
                    disabled={mobileNumber ? true : false}
                  />
                </div>
              </div>
            </div>

            <div className='col-12 col-sm-12 col-md-12 col-lg-12 col-xl-6'>
              <div>
                <SelectTextArea
                  isRequired
                  label='Address'
                  register={register('user_fair_member_company_address')}
                  placeholder='Enter Address'
                  defaultValue={address}
                />
              </div>
            </div>
            <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-12 mt-2'>
              <div className='row'>
                <div className='col-12 col-sm-12 col-md-12 col-lg-6 col-xl-3'>
                  <CommonImageUpload
                    fileName='user_fair_member_company_logo'
                    register={register}
                    setError={setError}
                    clearErrors={clearErrors}
                    setValue={setValue}
                    resetField={resetField}
                    errors={errors}
                    label='Company Logo'
                    onChange={(e: any) => {}}
                    required={logo ? false : true}
                    defaultValue={logo}
                    fullImageUrl
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyProfile;
